/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffSignedurlUploadVideoRequest
 */
export interface PostLiffSignedurlUploadVideoRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffSignedurlUploadVideoRequest
     */
    filePath: string;
}

/**
 * Check if a given object implements the PostLiffSignedurlUploadVideoRequest interface.
 */
export function instanceOfPostLiffSignedurlUploadVideoRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filePath" in value;

    return isInstance;
}

export function PostLiffSignedurlUploadVideoRequestFromJSON(json: any): PostLiffSignedurlUploadVideoRequest {
    return PostLiffSignedurlUploadVideoRequestFromJSONTyped(json, false);
}

export function PostLiffSignedurlUploadVideoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffSignedurlUploadVideoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filePath': json['filePath'],
    };
}

export function PostLiffSignedurlUploadVideoRequestToJSON(value?: PostLiffSignedurlUploadVideoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filePath': value.filePath,
    };
}

